<app-breadcrumb
  [title]="'Ново съобщение'"
  [items]="['Поща']"
  [active_item]="'Ново съобщение'"
></app-breadcrumb>
<div class="container-fluid">
  <div class="email-wrap">
    <div class="row">
      <div class="col-xl-3 box-col-30 col-md-6 xl-30">
        <app-email-filter></app-email-filter>
      </div>
      <div class="col-xl-9 box-col-8 col-md-12 xl-70">
        <div class="email-right-aside">
          <div class="card email-body">
            <div class="email-profile">
              <div class="email-body">
                <div class="email-compose">
                  <div class="email-top compose-border">
                    <div class="compose-header">
                      <h3 class="mb-0">Ново съобщение</h3>
                    </div>
                  </div>
                  <div class="email-wrapper">
                    <form class="theme-form">
                      <!-- Recipient Input with Chips -->
                      <div class="form-group recipient-group">
                        <label class="col-form-label pt-0">До <span class="text-danger">*</span></label>

                        <!-- Selected Recipients as Chips -->
                        <div class="recipient-chips" *ngIf="selectedRecipients.length > 0">
                          <div class="chip" *ngFor="let recipient of selectedRecipients"
                               [class.company]="recipient.isCompany"
                               [title]="recipient.email + ' · ' + recipient.identifier">
                            <i class="fa" [class.fa-building]="recipient.isCompany" [class.fa-user]="!recipient.isCompany"></i>
                            <span class="chip-name">{{ recipient.name }}</span>
                            <button type="button" class="chip-remove" (click)="removeRecipient(recipient)">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                          <button type="button" class="btn btn-link btn-sm clear-all"
                                  *ngIf="selectedRecipients.length > 1"
                                  (click)="clearAllRecipients()">
                            Изчисти всички
                          </button>
                        </div>

                        <!-- Search Input -->
                        <div class="recipient-search-wrapper">
                          <input
                            #recipientInput
                            class="form-control"
                            type="text"
                            placeholder="Търсене на получател..."
                            [value]="searchTerm"
                            (input)="onSearchInput($event)"
                            (keydown)="onKeyDown($event)"
                            (blur)="onInputBlur()"
                            autocomplete="off"
                            aria-label="Търсене на получатели"
                            [attr.aria-expanded]="showDropdown"
                            role="combobox"
                          />

                          <!-- Loading indicator -->
                          <div class="search-loading" *ngIf="isSearching">
                            <i class="fa fa-spinner fa-spin"></i>
                          </div>

                          <!-- Search Results Dropdown -->
                          <div class="recipient-dropdown" *ngIf="showDropdown" role="listbox">
                            <div class="dropdown-item"
                                 *ngFor="let profile of searchResults; let i = index"
                                 [class.selected]="isAlreadySelected(profile)"
                                 [class.highlighted]="i === highlightedIndex"
                                 (mousedown)="selectRecipient(profile)"
                                 (mouseenter)="highlightedIndex = i"
                                 role="option"
                                 [attr.aria-selected]="isAlreadySelected(profile)">
                              <div class="profile-icon">
                                <i class="fa" [class.fa-building]="profile.isCompany" [class.fa-user]="!profile.isCompany"></i>
                              </div>
                              <div class="profile-info">
                                <div class="profile-name">{{ profile.name }}</div>
                                <div class="profile-meta">{{ profile.email }} · {{ profile.identifier }}</div>
                              </div>
                              <div class="selected-check" *ngIf="isAlreadySelected(profile)">
                                <i class="fa fa-check"></i>
                              </div>
                            </div>
                            <div class="dropdown-empty" *ngIf="searchResults.length === 0 && !isSearching">
                              Няма намерени резултати
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Subject -->
                      <div class="form-group">
                        <label>Тема <span class="text-danger">*</span></label>
                        <input
                          class="form-control"
                          type="text"
                          [(ngModel)]="subject"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Въведете тема..."
                        />
                      </div>

                      <!-- Message Body -->
                      <div class="form-group">
                        <label>Съобщение <span class="text-danger">*</span></label>
                        <textarea
                          class="form-control message-textarea"
                          rows="10"
                          [(ngModel)]="body"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Въведете съобщение..."
                        ></textarea>
                      </div>

                      <!-- File Upload -->
                      <div class="form-group">
                        <label>Прикачени файлове</label>
                        <div class="dropzone digits text-center">
                          <ngx-dropzone
                            (change)="onSelect($event)"
                            [multiple]="true"
                          >
                            <ngx-dropzone-label>
                              <div>
                                <div class="dz-message needsclick">
                                  <i class="icon-cloud-up"></i>
                                  <h6>Провлачете файлове тук или кликнете за качване</h6>
                                </div>
                              </div>
                            </ngx-dropzone-label>
                            <ngx-dropzone-preview
                              *ngFor="let f of files"
                              [removable]="true"
                              (removed)="onRemove(f)"
                            >
                              <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                            </ngx-dropzone-preview>
                          </ngx-dropzone>
                        </div>
                      </div>
                    </form>

                    <!-- Actions -->
                    <div class="action-wrapper">
                      <ul class="actions">
                        <li>
                          <button
                            class="btn btn-primary"
                            type="button"
                            [disabled]="isSending || !isFormValid()"
                            (click)="sendMessage()">
                            <i class="fa fa-paper-plane me-2" *ngIf="!isSending"></i>
                            <i class="fa fa-spinner fa-spin me-2" *ngIf="isSending"></i>
                            {{ isSending ? 'Изпращане...' : 'Изпрати' }}
                          </button>
                        </li>
                        <li>
                          <button
                            class="btn btn-outline-secondary ms-2"
                            type="button"
                            [disabled]="isSending"
                            (click)="cancel()">
                            <i class="fa fa-times me-2"></i>Отказ
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
